import React from "react";
import pages from "../../../scripts/myga-ui";
import "./ProcessOverview.css";
import ProcessOverviewItem from "./ProcessOverviewItem";
import AppPageHeader from "../AppPageHeader/AppPageHeader";
import ProcessOverviewPlanItem from "./ProcessOverviewPlanItem";
import {Container, Row} from "react-bootstrap";
import {STORAGE_KEYS} from "../../../scripts/constants";
import Resources from "../../../Resources/Resources";
import {mygaSession} from "../../../scripts/myga-session";
import {startApplication} from "../../../scripts/sync-manager";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import {NassauLog} from "../../../scripts/myga-utils"

class ProcessOverview extends React.Component {

  constructor(props) {
    super(props);
    // setup default prev/next pages with props overrides
    // this.prevPage = props.prevPage   || PAGES.pageDashboard; // 2021.07.14.ADivelbiss - commented in favor of PageManager page stack solution
    // this.nextPage = props.nextPage   || PAGES.pageAppPremium;  // 2021.07.15.ADivelbiss - commented in favor of PageManager getNextPage solution
    
    // 2021.07.17.ADivelbiss - Handle signing state
    const appStateAbbr =  mygaSession.getMygaSessionValue(STORAGE_KEYS.AppStateAbbr);
    // set the state variation
    this.stateVar = appStateAbbr.length>0 ? `_${appStateAbbr}` : '';
  }
  
  componentDidMount() {
    // Get the current application
    let app = mygaSession.getCurrentApp();
    if (app===null) {
      // request a new application from the backend
      startApplication()
          .then((data)=>{
            NassauLog("app: " + JSON.stringify(data));
            // Got it! OK to continue.
          })
          .catch((err) => {
            NassauLog(err);
            // TODO: Handle the error. Message popup?
          });
    } else {
      // OK continue on.
    }
    
  }

  onNextPressed = async () => {
  }
  
  render() {
    
    return (

        <AppContentWrapper
            onNextPressed={this.onNextPressed}
            updatePage={this.props.updatePage}
            noXPadding>

          <AppPageHeader headerId={pages.process_overview.html.text_handy_title}
                         headerLabel={Resources.Strings.ProcessOverview_HandyTitle} />
          
          <Row>
            <Container>
      
              <ProcessOverviewItem itemId={pages.process_overview.html.text_item_id}
                                   itemIcon={Resources.Icons.IdCard}
                                   itemLabel={Resources.Strings.ProcessOverview_ItemsIdLabel} />
      
              <ProcessOverviewItem itemId={pages.process_overview.html.text_item_ssn}
                                   itemIcon={Resources.Icons.Key}
                                   itemLabel={Resources.Strings.ProcessOverview_ItemsSsnLabel} />
      
              <ProcessOverviewItem itemId={pages.process_overview.html.text_item_birthdays}
                                   itemIcon={Resources.Icons.BirthdayCake}
                                   itemLabel={Resources.Strings.ProcessOverview_ItemsDobsLabel} />
      
              <ProcessOverviewItem itemId={pages.process_overview.html.text_item_bank_info}
                                   itemIcon={Resources.Icons.PiggyBank}
                                   itemLabel={Resources.Strings.ProcessOverview_ItemsBankInfoLabel} />
    
    
            </Container>
  
          </Row>
  
          <AppPageHeader headerId={pages.process_overview.html.text_game_plan}
                         headerLabel={Resources.Strings.ProcessOverview_PlanTitle} />
  
          <Row>
    
            <Container>
      
              <ProcessOverviewPlanItem planNumber={Resources.CircleNumbers.One}
                                       planLabel={Resources.Strings.ProcessOverview_Plan1Desc}
                                       planEstimate={Resources.Strings[`ProcessOverview_Plan1Est${this.stateVar}`]}/>
      
              <ProcessOverviewPlanItem planNumber={Resources.CircleNumbers.Two}
                                       planLabel={Resources.Strings.ProcessOverview_Plan2Desc}
                                       planEstimate={Resources.Strings[`ProcessOverview_Plan2Est${this.stateVar}`]}/>
      
              <ProcessOverviewPlanItem planNumber={Resources.CircleNumbers.Three}
                                       planLabel={Resources.Strings.ProcessOverview_Plan3Desc}
                                       planEstimate={Resources.Strings[`ProcessOverview_Plan3Est${this.stateVar}`]}/>
      
              <ProcessOverviewPlanItem planNumber={Resources.CircleNumbers.Four}
                                       planLabel={Resources.Strings.ProcessOverview_Plan4Desc}
                                       planEstimate={Resources.Strings[`ProcessOverview_Plan4Est${this.stateVar}`]}/>
      
              <ProcessOverviewPlanItem planNumber={Resources.CircleNumbers.Five}
                                       planLabel={Resources.Strings.ProcessOverview_Plan5Desc}
                                       planEstimate={Resources.Strings[`ProcessOverview_Plan5Est${this.stateVar}`]}/>
      
              <ProcessOverviewPlanItem planNumber={Resources.CircleNumbers.Six}
                                       planLabel={Resources.Strings.ProcessOverview_Plan6Desc}
                                       planEstimate={Resources.Strings[`ProcessOverview_Plan6Est${this.stateVar}`]}/>
    
            </Container>
          </Row>
          
        </AppContentWrapper>
    
    );
  }
}

export default ProcessOverview;